import React from 'react';
export function Testimonials() {
  const testimonials = [{
    text: 'Cuando llegué al capítulo de las lealtades invisibles entendí por qué me saboteaba cada vez que me iba bien en el trabajo. Era la lealtad ciega a mi mamá que siempre fue pobre. Lloré dos horas y sentí que algo se movió en mi pecho para siempre.',
    author: 'Valeria M., 38 años, Buenos Aires'
  }, {
    text: 'Hice el ritual de las 7 velas un martes a la noche y al otro día me desperté sin ese peso en el vientre que tenía hace años. No lo puedo explicar racionalmente pero algo en mi cuerpo sabe que cambió.',
    author: 'Romina G., 42 años, Córdoba'
  }, {
    text: "El bono de los mantras lo uso todas las mañanas. Empecé con 'mi útero es hogar seguro' y no podía ni leerlo sin llorar. Hoy lo digo y siento paz. Eso solo ya valió toda la inversión.",
    author: 'Lucía F., 33 años, Rosario'
  }, {
    text: 'Pensé que era otro libro de autoayuda más. Pero desde la primera página sentí que alguien finalmente entendía lo que yo sentía. El capítulo del genograma me mostró un patrón de 4 generaciones de mujeres que se quedaron solas. Eso me cambió la vida.',
    author: 'Martina C., 45 años, Mendoza'
  }];
  return <section className="py-12 px-4 bg-cream" data-id="element-306">
      <div className="max-w-5xl mx-auto" data-id="element-307">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-308">
          Lo que dicen las mujeres que ya empezaron su proceso:
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-309">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-soft border border-soft-rose relative" data-id="element-310">
              <div className="text-3xl absolute top-3 left-3 text-soft-rose opacity-50 font-serif" data-id="element-311">
                "
              </div>
              <p className="text-base text-warm-brown-dark italic mb-4 relative z-10 pt-3" data-id="element-312">
                "{t.text}"
              </p>
              <div className="flex flex-col gap-1 border-t border-soft-rose pt-3" data-id="element-313">
                <div className="flex text-yellow-400 text-xs" data-id="element-314">⭐⭐⭐⭐⭐</div>
                <p className="font-bold text-warm-brown text-sm" data-id="element-315">{t.author}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}